import { formatNumber } from "~/utils/formatting"
import { filterNotUndefinedOrNull } from "~/utils/tsUtils"
import { type CollectionTableData } from "~/hooks/useCollectionTableData"

type OutData = {
  outSkuIds: string[]
  outCount: number
  productionCount: number
}

type AggregatedOutData = {
  outSkuIds: string[]
  outCount: number
  totalProductionCount: number
}

export function getOutStatus(outCount: number, productionCount: number): string {
  if (outCount === 0) return "No Outs"
  if (outCount === productionCount) return "All Out"
  return "Partially Out"
}

export function formatOutDisplay(outCount: number, productionCount: number): string {
  if (productionCount === 0) return "-"
  return `${formatNumber(outCount, 0)} out of ${formatNumber(productionCount, 0)} SKUs`
}

export function createOutColumnHelpers(maps: CollectionTableData) {
  const getOutData = (variantId: string | undefined): OutData => {
    const outSkuIds = filterNotUndefinedOrNull(maps?.outMap?.get(variantId ?? "") || [])
    const productionCount = maps?.productionSkuCountMap?.get(variantId ?? "") || 0
    return { outSkuIds, outCount: outSkuIds.length, productionCount }
  }

  const aggregateOutData = (leafChildren: any[]): AggregatedOutData => {
    const outSkuIdsSet = new Set<string>()
    let totalProductionCount = 0
    for (const child of leafChildren) {
      const { outSkuIds, productionCount } = getOutData(child.data?.variantId)
      outSkuIds.forEach((id) => outSkuIdsSet.add(id))
      totalProductionCount += productionCount
    }
    return {
      outSkuIds: Array.from(outSkuIdsSet),
      outCount: outSkuIdsSet.size,
      totalProductionCount,
    }
  }

  return { getOutData, aggregateOutData }
}
